import { LOGIN_SUCCESS, LOGIN_FAILED, LOCKOUT,LOGOUT_SUCCESS, MFA_REQUIRED, ACCOUNT_SERVICE_STATUS_UPDATED } from '../../actions/actionTypes';

const initialState = {
    account: null,
    loginError: false,
    mfaRequired: false,
    accountServiceEnabled: false,
    lockout: false,
    previewBannerEnabled: false
};

const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return Object.assign({}, state, {
                account: action.profile,
                loginError: false,
                mfaRequired: false,
                lockout: false
            });

        case LOGIN_FAILED:
            return Object.assign({}, state, {
                account: null,
                loginError: true,
                mfaRequired: false,
                lockout: false
            });

        case LOCKOUT:
            return Object.assign({}, state, {
                account: null,
                loginError: false,
                mfaRequired: false,
                lockout: true
            });

        case MFA_REQUIRED:
            return Object.assign({}, state, {
                account: null,
                loginError: false,
                mfaRequired: true,
                lockout: false
            });

        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                account: null,
                loginError: false,
                mfaRequired: false,
                lockout: false
            });

        case ACCOUNT_SERVICE_STATUS_UPDATED:
            return Object.assign({}, state, {
                accountServiceEnabled: action.enabled,
                previewBannerEnabled: action.preview_banner_enabled
            });

        default:
            return state;
    }
};

export default loginReducer;
